<template>
  <div class="container">
         <div class="tabList">
              <div class="tab" v-for="(item, index) in tabList" :key="index" @click="tabMenu(item)"
                :class="{'activeIndex': active == item.id}">
                {{item.name}}
              </div>
          </div>
          <div class="rightContent">
            <div class="list">
                <template v-if="list.length">
                <!--一条数据开始-->
                <div class="listItem" v-for="item in list" :key="item.id">
                    <div class="pageTitle">
                    <span class="name">
                        {{item.title}}
                    <span class="status status1" v-if="item.applyStatus === 1">应用已申请</span>
                    <span class="status status2" v-if="item.applyStatus === 0">未申请</span>
                    </span>
                    <div class="btn" @click="checkDetail(item)">
                        <!-- <a :href="item.linkUrl ? item.linkUrl : ''" target="_blank"> -->
                        <div>查看详情</div>
                        <img src="../../../assets/images/rightArrow.png" alt="">
                        <!-- </a> -->
                    </div>
                    </div>
                    <!-- <div class="pageContent">
                    <div>
                        <span class="label">申请企业</span>
                        <span>{{item.companyName}}</span>
                    </div>
                    <div>
                        <span class="label">联系电话</span>
                        <span>{{item.phone}}</span>
                    </div>
                    <div>
                        <span class="label">申请用途</span>
                        <span>{{item.applicant}}</span>
                    </div>
                    </div> -->
                    <div class="pageContent">
                    <div class="ts">
                        <span class="label">应用描述</span>
                        <span>{{item.describe}}</span>
                    </div>
                    </div>

                </div>
                <!--一条数据结束-->
                </template>
                <template v-else>
                <Nodata />
                </template>
            </div>
            <div class="pageBox">
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next"
                :total="total">
                </el-pagination>
            </div>
          </div>
          
         
    <AppDetailDialog ref="appDetailDialog"/>
  </div>
</template>
<script>
import Nodata from '@/components/noData.vue'
import { fetchAllCategory, fetchAllAppByFL2 } from '@/api/api'
import AppDetailDialog from './AppDetailDialog.vue'
export default {
    data() {
      return {
        total: 0,
        pageNum: 1,
        pageSize: 10,
        list: [],
        loading: false,
        
        active: 'all',
        tabList:[
            {
                name: '全部',
                id: 'all'
            },
        ],
      }
    },
    created() {
      this.getTypes()
      this.getList()
    },
    components: {
      AppDetailDialog,
      Nodata
    },
    methods: {
      tabMenu(item) {
        this.active = item.id
        this.pageNum = 1
        this.getList()
      },
      checkDetail(item) {
          this.$refs.appDetailDialog.openDialog(item.id, item.applyStatus)
      },
      getTypes() {
        let v=this
        fetchAllCategory().then(res => {
            v.tabList = [...v.tabList, ...res.data]
        })
      },
      getList() {
        let params = {
          page: this.pageNum - 1,
          size: this.pageSize,
        }
        if(this.active!=='all') {
            params.type = this.active
        }
        fetchAllAppByFL2(params).then(res => {
          this.list = res.data.content
          this.total = Number(res.data.totalElements)
        })
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getList()
      },

    }
} 
</script>
<style scoped>
.list{
    height: calc(100vh - 300px);
    overflow-y: scroll;
  }
  .list::-webkit-scrollbar { width: 0 !important }
  .pageBox{
    display: flex;
    justify-content: flex-end;
  }
  .listItem {
    padding: 10px 0 10px 10px;
    border-bottom: 1px solid #E8EBF4;
    position: relative;
    box-sizing: border-box;
  }
  .pageTitle {
    padding: 15px 0;
  }
  .pageContent {
    padding: 15px 0 0;
    display: flex;
    justify-content: flex-start;
  }

  .pageContent > div {
    width: 30%;
  }
  .pageContent > div.ts{
      width: 85%;
  }
  .label{
    color: #909DB1;
    padding-right: 20px;
    min-width: 80px;
  }

    .btn {
    width: 135px;
    height: 43px;
    border: 1px solid #0F5EFF;
    border-radius: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0px;
    bottom: 20px;
    cursor: pointer;

  }
  .btn a {
    display: block;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .btn img {
    margin-top: 3px;
    margin-left: 5px;
    /* width: 18px;
    height: 9px; */
  }

  .btn  div {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0F5EFF;
    text-align: center;
    /* line-height: 43px; */
  }


  .status {
    background: rgba(34,94,253,0.1);
    border: 1px solid #225EFD;
    border-radius: 22px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #225EFD;
    text-align: center;
    padding: 3px 15px;
    margin-left: 10px;
  }
  .status0{

  }
  .status1{
    background: rgba(13,193,110,0.1);
    color: #29C87E;
    border: 1px solid #0DC16E;
  }
  .status2{
    background: rgba(255,111,5,0.1);
    color: #FF8D3A;
    border: 1px solid #FF8D3A;
  }
  .container {
      display: flex;
  }
  .tabList{
      width: 180px;
      border-right: 1px solid #E1E1F0;
      /* border-right: 1px solid #F00; */
  }
  
  .tab{
    width: 180px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    font-size: 18px;
    /* font-family: "Source Han Sans CN"; */
    font-weight: 400;
    margin: 25px 0;
  }
  .tab.activeIndex{
      color: #225EFD;
      border-right: 2px solid #225EFD;
  }
  .tab:hover{
      color: #225EFD;
      border-right: 2px solid #225EFD;
  }
  .rightContent{
      flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/views/console/components/AppMarket.vue